<template>
  <v-container>
    <v-row column>
      <v-col cols="12">
        <SiteSelect :site="site" @site-selected="siteSelected"></SiteSelect>
      </v-col>
      <router-view name="banner" :site_key="site"></router-view>
    </v-row>
  </v-container>
</template>

<script>
import SiteSelect from '@/components/SiteSelect'
import list_view from '@/mixins/list_view'

export default {
  name: 'banners_index',
  components: { SiteSelect },
  mixins: [list_view],
}
</script>
